import { Button, Grid, Group, Layout, Page } from "@/comn/components";
import { useFetch, useForm, useGrid, useModal, usePage, useStore, useTheme } from "@/comn/hooks";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { comnUtils } from "@/comn/utils";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { APIS, SF_AUTH_MENU_LIST, SG_MENU_LIST, URLS } from "@/tra/tancis/ptli/ptl/cotpauth/service/PtliCoTpService";
import dayjs from "dayjs";

/*
 * Custom Office User Role History Management List
 * !== 세관 사용자 권한 이력 목록 ==!
 */
export const PTLI1008012Q = (): JSX.Element => {
    const { pgeUid } = usePage({
        auth: ["auth_ptli0015", "auth_ptlianyADM"],
    });
    const modal = useModal();
    const { theme } = useTheme();
    const { pgeStore, setStore, getStore } = useStore({ pgeUid: pgeUid });
    const { t } = useTranslation(); // Translation Hook !== 언어 변환 Hook ==!
    const [load, setLoad] = useState(false);
    const navigate = useNavigate();

    const location = useLocation();
    const { formData, rowData } = location.state || {};

    const { authId } = useParams<{ authId: string }>();

    const form = {
        form_coTpSrch: useForm({ defaultSchema: SF_AUTH_MENU_LIST }),
    };

    const grid = {
        gridCoTpAuthList: useGrid({
            defaultSchema: SG_MENU_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    const fetch = {
        getCoTpMenuAuthList: useFetch({
            api: (id, page = grid.gridCoTpAuthList.page, size = grid.gridCoTpAuthList.size) =>
                APIS.getCoTpMenuAuthList(id, page, size),
            key: [grid.gridCoTpAuthList.page, grid.gridCoTpAuthList.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    ...pgeStore,
                    form: form.form_coTpSrch.getValues(),
                    page: grid.gridCoTpAuthList.page,
                    size: grid.gridCoTpAuthList.size,
                });
            },
            onError: () => modal.openModal({ content: "msg.com.00025" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),
    };

    useEffect(() => {
        if (authId) {
            fetch.getCoTpMenuAuthList.fetch(authId, grid.gridCoTpAuthList.page, grid.gridCoTpAuthList.size);
        }
    }, [authId, grid.gridCoTpAuthList.page, grid.gridCoTpAuthList.size]);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control label="coTpCd" value={formData?.coTpCd} edit={false} />
                            <Group.Control label="authId" value={authId} edit={false} />
                        </Group.Row>
                    </Group.Section>
                </Group.Body>
            </Group>

            <Group>
                <Group.Body>
                    <Group.Title title={"T_MENU_LIST"} />
                    <Grid {...grid.gridCoTpAuthList.grid} data={fetch.getCoTpMenuAuthList.data?.coTpMenuAuthList} />
                </Group.Body>
            </Group>

            <Layout direction="row">
                <Layout.Left>
                    <Button role="list" onClick={() => navigate(URLS.ptli1008008q)} />
                </Layout.Left>
            </Layout>
        </Page>
    );
};
